import { root, id } from './suggestions';

export const suggestions = {
  ...root,
  id,
};
